export default "__VITE_ASSET__b5a319a1__"